module.exports = __webpack_public_path__ + "img/logout.8fe27820.svg";